export const serviceLogoUrl = service => {
    if (!service?.logo) return '';
    const filename = service.logo.split('/').pop();
    if (filename === '1738094830logo192.png') return `https://apizone.servicezone.com.tr/images/service_logos/${filename}`;
    if (service.logo_url) return service.logo_url;
    if (service.logo_storage_type === 's3') {
        const path = service.logo.startsWith('service_logos/') ? service.logo : `service_logos/${service.logo}`;
        return `https://servicezone-storage.s3.amazonaws.com/${path}`;
    }
    return `https://apizone.servicezone.com.tr/images/service_logos/${service.logo}`;
};
